import { type ReactNode, createContext, useContext } from 'react';

import { useWindowSize } from 'usehooks-ts';


type TResponsiveContext = {
  atLeastMediumWidth: boolean;
  isNarrowWidth: boolean;
  isSmallWidth: boolean;
  isMediumWidth: boolean;
  isWideWidth: boolean;
  height: number;
  width: number;
};

const ResponsiveContext = createContext<TResponsiveContext | undefined>(
  undefined,
);

export function ResponsiveProvider(props: { children: ReactNode }) {
  const { height, width } = useWindowSize({
    debounceDelay: 250,
  });

  // Possible view modes: narrow, small, medium, wide
  // To check if we're at least small width, check !isNarrowWidth
  const viewportInfo = {
    // atLeastMediumWidth is provided to avoid checking (isMediumWidth || isWideWidth)
    atLeastMediumWidth: width >= 730,
    isNarrowWidth: width < 512,
    isSmallWidth: width >= 512 && width < 730,
    isMediumWidth: width >= 730 && width < 1100,
    // No atLeastWideWidth because that's identical to isWideWidth
    isWideWidth: width >= 1100,
    height,
    width,
  };

  return (
    <ResponsiveContext.Provider value={viewportInfo}>
      {props.children}
    </ResponsiveContext.Provider>
  );
}

export function useResponsive() {
  const context = useContext(ResponsiveContext);
  if (!context) {
    throw new Error('useResponsive must be used within a ResponsiveProvider');
  }
  return context;
}
